import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'



export const Root = () => {
  useEffect(() => {

  }, [])

  return (
    <>
      <div className="h-full">
        <Outlet />
      </div>
    </>
  )
}
